exports = module.exports = require("/home/kwok/projects/brewplanner/brewplanner-ui/node_modules/css-loader/cssToString.js")();
exports.push([module.id, ".bp-history-modal-description{display:flex;justify-content:space-between;width:80%}.bp-history-modal-description__field{line-height:4em;height:4em}.bp-history-modal-description__field-column-name{padding-bottom:.5em;padding-left:.9em}.bp-history-modal-description__field-value{padding-left:.9em;font-size:1em}", ""]);


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/views/HistoryAdmin/HistoryModal/HistoryModalDescription.scss
 ** module id = 289
 ** module chunks = 0
 **/